import { useTranslation } from 'react-i18next';

import './terms-and-conditions-button.scss';

interface TermsAndConditionsButtonProps {
    label: string;
    onClick: () => void;
}

const TermsAndConditionsButton = ({ onClick, label }: TermsAndConditionsButtonProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div className={'terms-and-conditions-button'} onClick={onClick}>
            {t(label)}
        </div>
    );
};

export default TermsAndConditionsButton;
